<app-spinner></app-spinner>

<div class="container" style="max-width: 75% !important;" id="contact" *ngIf="!this.apierror">

  <div>
    <h1 class="text-center">Benutzer {{ this.getOperation() }}</h1>
  </div>

  <div class="form">
    <!--TODO Form Validation-->
    <form role="form" class="php-email-form" [formGroup]="userform" (ngSubmit)="this.onSubmit()">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="username" class="form-label">
            Benutzername
          </label>
          <input type="text" name="username" class="form-control" id="username"
                 placeholder="Benutzername*" formControlName="username" required
                 [class.is-invalid]="(this.getFormControls()['username'].touched || this.getFormControls()['username'].dirty) && this.getFormControls()['username'].invalid">
          <div *ngIf="this.getFormControls()['username'].touched && this.getFormControls()['username'].invalid"
               class="alert alert-danger">
            <div *ngIf="this.getFormControls()['username'].errors?.['required']">Der Titel ist erforderlich.</div>
            <div *ngIf="this.getFormControls()['username'].errors?.['pattern']">Der Titel enthält ein ungültiges
              Zeichen.
            </div>
            <div *ngIf="this.getFormControls()['username'].errors?.['minlength']">Der eingegebene Titel ist zu kurz
            </div>
          </div>
        </div>


        <div class="form-group col-md-4">
          <label for="customer" class="form-label">
            Kunde
          </label>
          <select class="form-control" name="customer" id="customer"
                  formControlName="customer" title="customer">
            <option value="" selected disabled hidden="hidden">Bitte Kunde wählen</option>
            <option *ngFor="let customer of this.customers"
                    value="{{customer.uuid}}">{{ customer.display_name + " (" + customer.company_name + ")" }}
            </option>
          </select>
        </div>

        <div class="form-group col-md-6">
          <label for="name" class="form-label">
            Vorname
          </label>
          <input type="text" name="name" class="form-control" id="name"
                 placeholder="Vorname" formControlName="name"
                 [class.is-invalid]="(this.getFormControls()['name'].touched || this.getFormControls()['name'].dirty) && this.getFormControls()['name'].invalid">
          <div *ngIf="this.getFormControls()['name'].touched && this.getFormControls()['name'].invalid"
               class="alert alert-danger">
            <div *ngIf="this.getFormControls()['name'].errors?.['pattern']">Die User ID enthält ein ungültiges
              Zeichen.
            </div>
            <div *ngIf="this.getFormControls()['name'].errors?.['minlength']">Die User ID ist zu kurz</div>
            <div *ngIf="this.getFormControls()['name'].errors?.['maxlength']">Die User ID ist zu lang</div>
          </div>
        </div>

        <div class="form-group col-md-6">
          <label for="lastname" class="form-label">
            Nachname
          </label>
          <input type="text" name="lastname" class="form-control" id="lastname"
                 placeholder="Nachname" formControlName="lastname"
                 [class.is-invalid]="(this.getFormControls()['name'].touched || this.getFormControls()['name'].dirty) && this.getFormControls()['name'].invalid">
          <div *ngIf="this.getFormControls()['name'].touched && this.getFormControls()['name'].invalid"
               class="alert alert-danger">
            <div *ngIf="this.getFormControls()['name'].errors?.['pattern']">Die User ID enthält ein ungültiges
              Zeichen.
            </div>
            <div *ngIf="this.getFormControls()['name'].errors?.['minlength']">Die User ID ist zu kurz</div>
            <div *ngIf="this.getFormControls()['name'].errors?.['maxlength']">Die User ID ist zu lang</div>
          </div>
        </div>

        <div class="form-group col-md-6">
          <label for="permissions" class="form-label">Berechtigungen</label>
          <select multiple class="form-control" name="permissions" id="permissions" formControlName="permissions" size="8">
            <option *ngFor="let permission of this.permissions" value="{{permission}}">{{ permission }}</option>
          </select>
        </div>

        <div class="pb-3">
          <div *ngIf="this.sentstatus === 1" class="sent-message">Der Benutzer wurde
            erfolgreich {{ this.operation === "edit" ? "Editiert" : "Erstellt" }}
          </div>
          <div *ngIf="this.sentstatus === 2" class="error-message">Der Benutzer konnte leider nicht
            erfolgreich {{ this.operation === "edit" ? "Editiert" : "Erstellt" }} werden
          </div>
          <div *ngIf="this.sentstatus === 3" class="error-message">Sie haben zu viele Anfragen gestellt, bitte versuchen
            Sie es später nochmal
          </div>
        </div>
        <div class="text-center">
          <button *ngIf="this.operation === 'edit' || this.operation === 'create'" type="submit"
                  class="btn btn-success mb-3">Speichern
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
